const KNOWN_MODS_REFS = {
	99999999: '- Remove <strong>???</strong>,<br/>' +
	'<em>Any other mod related to ???.</em>',
}

export const tunableResourceTest1 = ({
	buildsignature,
	categoryid,
	createtime,
	desyncdata,
	desyncid,
	screenshot,
	sessionid,
	sku,
	systemconfig,
	type,
	version,
}) => {
	if (desyncdata !== undefined) {
		if (desyncdata.indexOf('[cjiang] Caught exception loading reference.') !== -1) {
			const indexOfRefName = desyncdata.indexOf('RefName: ')
			const refId = desyncdata.slice(indexOfRefName, indexOfRefName + 50).split(' ')[1].trim()
			var descModRef = ''

			if (refId in KNOWN_MODS_REFS) {
				descModRef = 'Known mods that cause issues like this:<br/>'
				descModRef += KNOWN_MODS_REFS[refId]
				descModRef += '<br/><br/>'
			}

			return {
				type: 'tunableResourceTest1' + refId,
				color: 'IndianRed',
				title: 'Outdated Tunable' + ((refId > 999999) ? ' ' : ' Override ') + 'Error',
				text: 'Outdated Tunable Resource requires removing.',
				description: ((refId > 999999) ? 'Custom Content Resource Modification' : 'Overridden Game Resource') + ' with <strong>identifier</strong> \'<a id="refId" onclick=\'copyClickedText("refId")\'>' + refId + '</a>\' contains incorrect/outdated information. <em>Click on one of the identifier to copy it</em>.<br/><br/>' +
				descModRef +
				'You can locate the PACKAGE file, in your The Sims 4 Mods folder, that contains this faulty resource using the <a href="http://modthesims.info/download.php?t=618042" target="_blank" rel="noopener noreferrer">TS4 Package Searcher (Windows Only) by Scumbumbo</a>.<br/><br/>' +
				'Enter the <strong>identifier</strong> into the \'Instance\' field and try removing or updating PACKAGE files that are pointing to the cause of the issue.'
			}
		}
	}
}

// EXAMPLE
/*
<root>
        <report>
                <version>2</version>
                <sessionid>5a38b6ec7ae9ca555b55e7a9</sessionid>
                <type>desync</type>
                <sku>ea.maxis.sims4_64.15.pc</sku>
                <createtime>2099-07-23 09:39:27</createtime>
                <buildsignature>Local.Unknown.Unknown.1.99.88.1020-1.200.000.354.Release</buildsignature>
                <categoryid>tunable.py:2171</categoryid>
                <desyncid>5a38b6ec7ae9ca555b55e7a9</desyncid>
                <systemconfig/>
                <screenshot/>
                <desyncdata>[cjiang] Caught exception loading reference. RefName: 16651 Manager: InstanceManager_statistic.
 TunableReference is set to a value that is not allowed by its class restriction. (ValueError: TunableReference is set to a value that is not allowed by its class restriction.)
Traceback (most recent call last):
    File &quot;T:\InGame\Gameplay\Scripts\Core\sims4\utils.py&quot;, line 179, in wrapper
ValueError: TunableReference is set to a value that is not allowed by its class restriction.
</desyncdata>
        </report>
</root>
*/

export const tunableResourceTest2 = ({
	buildsignature,
	categoryid,
	createtime,
	desyncdata,
	desyncid,
	screenshot,
	sessionid,
	sku,
	systemconfig,
	type,
	version,
}) => {
	if (desyncdata !== undefined) {
		if (desyncdata.indexOf('Exception in') !== -1 && (desyncdata.indexOf('_tuning_loaded_callback. (AttributeError: \'NoneType\' object has no attribute') !== -1 || desyncdata.indexOf('_tuning_loaded_callback. (AttributeError: \'str\' object has no attribute') !== -1)) {
            const className = desyncdata.substr(desyncdata.indexOf('<class \'') + 8, desyncdata.indexOf('\'>._tuning_loaded_callback') - 29).split('.').slice(-1)[0]

			return {
				type: 'tunableResourceTest2',
				color: 'IndianRed',
				title: 'Outdated Tunable Resource Error',
				text: 'Outdated Tunable Resource requires removing.',
				description: 'Tunable Game Resource with name \'<strong>' + className + '</strong>\' contains incorrect/outdated information.<br/><br/>' +
				'You need to locate the PACKAGE file, in your The Sims 4 Mods folder, that contains this resource and remove it. Try starting with the oldest modifications you have.<br/>' +
				'If this is a new issue, try removing the most recent mod you have installed.'
			}
		}
	}
}

// EXAMPLE
/*
<root>
		<report>
				<version>2</version>
				<sessionid>59161b4a3a3151535b55657b</sessionid>
				<type>desync</type>
				<sku>ea.maxis.sims4_64.15.pc</sku>
				<createtime>2099-07-23 00:37:40</createtime>
				<buildsignature>Local.Unknown.Unknown.1.99.88.1020-1.200.000.347.Release</buildsignature>
				<categoryid>broadcaster_request.py:75</categoryid>
				<desyncid>59161b4a3a3151535b55657b</desyncid>
				<systemconfig/>
				<screenshot/>
				<desyncdata>[manus] Exception in &lt;class 'sims4.tuning.instances.guitar_Practice'&gt;._tuning_loaded_callback. (AttributeError: 'NoneType' object has no attribute 'register_static_callbacks')
Traceback (most recent call last):
	File &quot;T:\InGame\Gameplay\Scripts\Core\sims4\utils.py&quot;, line 179, in wrapper
	File &quot;T:\InGame\Gameplay\Scripts\Server\areaserver.py&quot;, line 150, in c_api_server_init_tick
	File &quot;T:\InGame\Gameplay\Scripts\Core\sims4\core_services.py&quot;, line 164, in start_service_tick
	File &quot;T:\InGame\Gameplay\Scripts\Core\sims4\service_manager.py&quot;, line 335, in start_single_service
	File &quot;T:\InGame\Gameplay\Scripts\Core\sims4\tuning\instance_manager.py&quot;, line 104, in update_incremental_start
	File &quot;T:\InGame\Gameplay\Scripts\Core\sims4\tuning\instance_manager.py&quot;, line 149, in _execute_gen
	File &quot;T:\InGame\Gameplay\Scripts\Core\sims4\tuning\instance_manager.py&quot;, line 477, in invoke_registered_callbacks_gen
	File &quot;T:\InGame\Gameplay\Scripts\Core\sims4\tuning\instance_manager.py&quot;, line 475, in invoke_registered_callbacks_gen
	File &quot;T:\InGame\Gameplay\Scripts\Server\interactions\base\super_interaction.py&quot;, line 1628, in _tuning_loaded_callback
	File &quot;T:\InGame\Gameplay\Scripts\Server\interactions\base\interaction.py&quot;, line 2203, in _tuning_loaded_callback
	File &quot;T:\InGame\Gameplay\Scripts\Server\broadcasters\broadcaster_request.py&quot;, line 75, in on_affordance_loaded_callback
AttributeError: 'NoneType' object has no attribute 'register_static_callbacks'
</desyncdata>
		</report>
</root>
*/

export const tunableResourceTest3 = ({
	buildsignature,
	categoryid,
	createtime,
	desyncdata,
	desyncid,
	screenshot,
	sessionid,
	sku,
	systemconfig,
	type,
	version,
}) => {
	if (desyncdata !== undefined) {
		if (desyncdata.indexOf('sims4.tuning.tunable_errors.TunableMinimumLengthError') !== -1) {
			return {
				type: 'tunableResourceTest3',
				color: 'IndianRed',
				title: 'Outdated Tunable Resource Error',
				text: 'Outdated Tunable Resource requires removing.',
				description: 'Tunable Game Resource contains incorrect/outdated information.<br/><br/>' +
				'You need to locate the PACKAGE file, in your The Sims 4 Mods folder, that contains this resource and remove it. Try starting with the oldest modifications you have.<br/>' +
				'If this is a new issue, try removing the most recent mod you have installed.'
			}
		}
	}
}

// EXAMPLE
/*
<root>
    <report>
        <version>2</version>
        <sessionid>321b5eab31e7a5ba5bad40bf</sessionid>
        <type>desync</type>
        <sku>ea.maxis.sims4_64.15.pc</sku>
        <createtime>2099-09-27 15:43:33</createtime>
        <buildsignature>Local.Unknown.Unknown.1.99.18.1020-1.200.000.364.Release</buildsignature>
        <categoryid>tunable.py:1595</categoryid>
        <desyncid>321b5eab31e7a5ba5bad40bf</desyncid>
        <systemconfig/>
        <screenshot/>
        <desyncdata>[manus] Exception while finalizing tuning for &lt;class 'sims4.tuning.instances.iceCream_PurchasePicker'&gt;. (TunableMinimumLengthError)
Traceback (most recent call last):
  File &quot;T:\InGame\Gameplay\Scripts\Core\sims4\utils.py&quot;, line 179, in wrapper
  File &quot;T:\InGame\Gameplay\Scripts\Server\areaserver.py&quot;, line 150, in c_api_server_init_tick
  File &quot;T:\InGame\Gameplay\Scripts\Core\sims4\core_services.py&quot;, line 164, in start_service_tick
  File &quot;T:\InGame\Gameplay\Scripts\Core\sims4\service_manager.py&quot;, line 335, in start_single_service
  File &quot;T:\InGame\Gameplay\Scripts\Core\sims4\tuning\instance_manager.py&quot;, line 104, in update_incremental_start
  File &quot;T:\InGame\Gameplay\Scripts\Core\sims4\tuning\instance_manager.py&quot;, line 144, in _execute_gen
  File &quot;T:\InGame\Gameplay\Scripts\Core\sims4\tuning\instance_manager.py&quot;, line 450, in load_data_into_class_instances
  File &quot;T:\InGame\Gameplay\Scripts\Core\sims4\tuning\instance_manager.py&quot;, line 433, in load_data_into_class_instances
  File &quot;T:\InGame\Gameplay\Scripts\Core\sims4\tuning\serialization.py&quot;, line 658, in load_from_xml
  File &quot;T:\InGame\Gameplay\Scripts\Core\sims4\tuning\serialization.py&quot;, line 703, in feed
  File &quot;T:\InGame\Gameplay\Scripts\Core\sims4\tuning\serialization.py&quot;, line 747, in _load_node
  File &quot;T:\InGame\Gameplay\Scripts\Core\sims4\tuning\serialization.py&quot;, line 796, in _load_tunable
  File &quot;T:\InGame\Gameplay\Scripts\Core\sims4\tuning\tunable.py&quot;, line 1188, in load_etree_node
  File &quot;T:\InGame\Gameplay\Scripts\Core\sims4\tuning\tunable.py&quot;, line 820, in load_etree_node
  File &quot;T:\InGame\Gameplay\Scripts\Core\sims4\tuning\tunable.py&quot;, line 371, in load_etree_node
  File &quot;T:\InGame\Gameplay\Scripts\Core\sims4\tuning\tunable.py&quot;, line 1595, in load_etree_node
sims4.tuning.tunable_errors.TunableMinimumLengthError
</desyncdata>
    </report>
</root>
*/

export const tunableResourceTest4 = ({
    buildsignature,
    categoryid,
    createtime,
    desyncdata,
    desyncid,
    screenshot,
    sessionid,
    sku,
    systemconfig,
    type,
    version,
}) => {
    if (desyncdata !== undefined) {
        if (desyncdata.indexOf('Exception during call to test method') !== -1) {
            return {
                type: 'tunableResourceTest4',
                color: 'IndianRed',
                title: 'Outdated Tunable Resource Error',
                text: 'Outdated Tunable Resource (Interaction) requires removing.',
                description: 'Tunable Game Resource (Interaction) contains incorrect/outdated information.<br/><br/>' +
                'You need to locate the PACKAGE file, in your The Sims 4 Mods folder, that contains this resource and remove it. Try starting with the oldest modifications you have.<br/>' +
                'If this is a new issue, try removing the most recent mod you have installed.'
            }
        }
    }
}


// WEBPACK FOOTER //
// ./src/tests/mods/tunableResourceTest.js